import { Loader2 } from 'lucide-react';

import { useRouteProtection } from '@/hooks/useRouteProtection';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isDataLoading, isOnAccountPage, shouldBlockContent } =
    useRouteProtection();

  if ((isDataLoading || shouldBlockContent) && !isOnAccountPage) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return <>{children}</>;
}
